export class SparePart {

    name : string = '';
    code : string = '';
    desc : string = '';
    id : string = null;
    minQty : number = null;
    maxQty : number = null;

    getName(){
        return this.name;
    }

    getCode(){
        return this.code;
    }

    getDesc(){
        return this.desc;
    }

    getId(){
        return this.id;
    }

    getMinQty(){
        return this.minQty;
    }

    getMaxQty(){
        return this.maxQty;
    }


    setName(name: string){
        this.name = name;
    }

    setCode(code: string){
        this.code = code;
    }

    setDesc(desc: string){
        this.desc = desc;
    }

    setId(id: string){
        this.id = id;
    }

    setMinQty(minQty: number){
        this.minQty = minQty;
    }

    setMaxQty(maxQty: number){
        this.maxQty = maxQty;
    }

}